Shopify.customSlider = function (element) {
  const slider = document.querySelector(element);
  if (slider) {
    let isDown = false;
    let startX;
    let scrollLeft;
    let scrolled;
    slider.addEventListener('mousedown', (e) => {
      isDown = true;
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });
    slider.addEventListener('mouseleave', () => (isDown = false));
    slider.addEventListener('click', (e) => {
      if (scrolled) {
        e.preventDefault();
        scrolled = false;
      }
    });
    slider.addEventListener('mouseup', () => (isDown = false));
    slider.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      slider.scrollLeft = scrollLeft - (x - startX);
      scrolled = true;
    });
  }
};
